var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:`cv-header ${_vm.carbonPrefix}--header`,attrs:{"data-header":""}},[_vm._t("default"),(_vm.hasGlobalHeader)?_c('div',{class:`${_vm.carbonPrefix}--header__global`},[_vm._t("header-global")],2):_vm._e(),_vm._t("left-panels"),_vm._t("right-panels")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }